import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

function TerminationDetail() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [terminationDetail, setTerminationDetail] = useState({
    terminationItemlist: [],
    terminationFeedbackList: [],
  });

  const resource = "termination-detail";
  const storedToken = localStorage.getItem("token");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    loadTerminationDetail(searchParams.get("param1"));
  }, []);

  const loadTerminationDetail = async (terminationId) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/termination-detail?terminationId=${terminationId}`
      );
      const data = result.data;

      setTerminationDetail(data);
    } catch (error) {
      console.error("Error loading termination list:", error);
    }
  };

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getUTCFullYear(); // Gunakan UTC
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Gunakan UTC
    const day = String(date.getUTCDate()).padStart(2, "0"); // Gunakan UTC
    return `${day}/${month}/${year}`;
  };

  const downloadExternalTerminationLetter = async (terminationId) => {
    try {
      // Step 1: Get the presigned download URL from your Lambda function
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/download-external-termination-letter?terminationId=${terminationId}`
      );
      const downloadUrl = result.data.downloadUrl;

      // Step 2: Fetch the file from the presigned URL
      const response = await fetch(downloadUrl, {
        method: "GET", // Use GET to download the file
      });

      const fileName = result.data.fileName;

      // Step 3: Convert the response to a Blob and create a downloadable link
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up after download
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="container-order-input">
      <h1 className="main-title">Cross Connect Termination Detail</h1>
      <div className="order-information-order-input">
        <div className="title-order-input">
          <h5>Termination Information</h5>
        </div>
        <div className="textbox-gray">
          <label htmlFor="terminationDate">Termination Date</label>
          <input
            type="text"
            placeholder={formatDate(terminationDetail.termination_date)}
            disabled
          />
        </div>
        <div className="textbox-gray">
          <label htmlFor="terminationPic">Termination PIC</label>
          <input
            type="text"
            placeholder={terminationDetail.termination_pic}
            disabled
          />
        </div>
        {/* Download External Termination Letter */}
        <div className="download-letter-section">
          <label className="download-label">
            Download External Termination Letter
          </label>
          <div className="download-file-container">
            <button
              type="button"
              className="download-button"
              onClick={() => {
                downloadExternalTerminationLetter(searchParams.get("param1"));
              }}
            >
              Download
            </button>
          </div>
        </div>
      </div>

      {terminationDetail.terminationItemlist &&
        terminationDetail.terminationItemlist.length > 0 &&
        terminationDetail.terminationItemlist.map((termination, index) => (
          <div>
            <div className="title-order-input">
              <h5>Termination Item ({index + 1})</h5>
            </div>
            <div className="box-two-part">
              <div className="requestor-information">
                <div className="textbox-gray">
                  <label htmlFor="companyName">Cable Id</label>
                  <input
                    type="text"
                    placeholder={termination.cable_id}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName">Company Name Requestor</label>
                  <input
                    type="text"
                    placeholder={termination.company_requestor}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="contactEmail">PIC Name Requestor</label>
                  <input
                    type="text"
                    placeholder={termination.pic_requestor}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="orderDate">Order Date</label>
                  <input
                    type="text"
                    placeholder={formatDate(termination.order_date)}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox" className="requestLocation">
                    Request Location
                  </label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">
                      {termination.order_location_name}
                    </option>
                  </select>
                </div>
                <div className="radio-button">
                  <label>Cross Connect Type</label>
                  <div className="radio-button-option">
                    <input
                      type="radio"
                      name={`connect-${index}`}
                      id="connect-one"
                      checked={termination.order_type_id === 1}
                      disabled
                    />
                    <label htmlFor={`connect-one-${index}`}>
                      Interconnection to other tenant device
                    </label>
                  </div>
                  <div className="radio-button-option">
                    <input
                      type="radio"
                      name={`connect-${index}`}
                      id="connect-two"
                      checked={termination.order_type_id === 2}
                      disabled
                    />
                    <label htmlFor={`connect-two-${index}`}>
                      Interconnection to your own device
                    </label>
                  </div>
                </div>
              </div>

              <div className="destination-information">
                <div className="textbox-gray">
                  <label htmlFor="cableStatus">Cable Status</label>
                  <input
                    type="text"
                    placeholder={termination.cable_status}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="companyNameDestination">
                    Company Name Destination
                  </label>
                  <input
                    type="text"
                    placeholder={termination.company_destination}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picNameDestination">
                    PIC Name Destination
                  </label>
                  <input
                    type="text"
                    placeholder={termination.pic_destination}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="installationDate">Installation Date</label>
                  <input
                    type="text"
                    placeholder={formatDate(termination.installation_date)}
                    disabled
                  />
                </div>

                <div className="textbox-gray">
                  <label htmlFor="salesOrderNumber">Sales Order Number</label>
                  <input
                    type="text"
                    placeholder={termination.sales_order_no}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="box-two-part">
              <div className="a-end-information">
                <div className="title-box-order-input">
                  <h5>A-end Information</h5>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">{termination.cable_type_a}</option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Interface</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">
                      {termination.interface_name_a}
                    </option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Floor</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">{termination.floor_name_a}</option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Room</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">{termination.room_name_a}</option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder={termination.a_end_rack_id}
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="cableQuantity">Cable Quantity</label>
                  <input
                    type="text"
                    placeholder={termination.cable_quantity}
                    disabled
                  />
                </div>
              </div>

              <div className="b-end-information">
                <div className="title-box-order-input">
                  <h5>B-end Information</h5>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">{termination.cable_type_b}</option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Interface</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">
                      {termination.interface_name_b}
                    </option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Floor</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">{termination.floor_name_b}</option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="comboBox">Room</label>
                  <select id="comboBox" name="options" disabled>
                    <option value="option1">{termination.room_name_b}</option>
                  </select>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder={termination.b_end_rack_id}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        ))}

      <div className="box-two-part">
        <div className="feedback-history">
          <h5>Termination Feedback History</h5>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">User</th>
                <th scope="col">User</th>
                <th scope="col" className="note-column">
                  Note
                </th>
              </tr>
            </thead>
            <tbody>
              {terminationDetail.terminationFeedbackList.map((termination) => (
                <tr>
                  <td>{formatDate(termination.feedback_date)}</td>
                  <td>{termination.username}</td>
                  <td className="note-column">{termination.feedback}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <a href="/termination-list" className="btn-back">
        Back
      </a>
    </div>
  );
}

export default TerminationDetail;